import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userChannelSlice, { fetchUserChannel, getUserChannel } from 'shared/reducers/UserChannelSlice';
import { useProfile } from '@brg/auth';
import ChannelsContext from 'shared/contexts/ChannelsContext';

interface IProps {
  children: React.ReactNode;
}

const ChannelsProvider: React.FC<IProps> = ({ children }) => {
  const dispatch = useDispatch();
  const profile = useProfile();
  const prevUser = useRef<any>(null);
  const { data, loading, error, activeChannel } = useSelector(getUserChannel);

  const channels = useMemo(() => data?.data , [data])

  useEffect(() => {
    if (!!profile && prevUser.current !== profile?.accountId ) {
      dispatch(fetchUserChannel({ accountId: profile?.accountId }));
    }
    prevUser.current = profile?.accountId
  }, [dispatch, channels, profile, loading, prevUser]);

  const refetch = useCallback(() => {
    if (!loading) dispatch(fetchUserChannel({ accountId: profile?.accountId }));
  } , [fetchUserChannel, loading, profile])

  const reset = useCallback(() => {
    if (!loading) dispatch(userChannelSlice.actions.setChannel({ activeChannel: undefined }));
  } , [fetchUserChannel, loading, profile])

  const contextValue = useMemo(() => ({ 
    channels, 
    loading, 
    error, 
    refetch, 
    reset, 
    activeChannel 
  }), [
    channels,
    loading,
    activeChannel,
    error,
    reset,
    refetch,
  ]);

  return <ChannelsContext.Provider value={contextValue}>{children}</ChannelsContext.Provider>;
};


export default ChannelsProvider;import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userChannelSlice, { fetchUserChannel, getUserChannel } from 'shared/reducers/UserChannelSlice';
import { useProfile } from '@brg/auth';
import ChannelsContext from 'shared/contexts/ChannelsContext';

interface IProps {
  children: React.ReactNode;
}

const ChannelsProvider: React.FC<IProps> = ({ children }) => {
  const dispatch = useDispatch();
  const profile = useProfile();
  const prevUser = useRef<any>(null);
  const { data, loading, error, activeChannel } = useSelector(getUserChannel);

  const channels = useMemo(() => data?.data , [data])

  useEffect(() => {
    if (!!profile && prevUser.current !== profile?.accountId ) {
      dispatch(fetchUserChannel({ accountId: profile?.accountId }));
    }
    prevUser.current = profile?.accountId
  }, [dispatch, channels, profile, loading, prevUser]);

  const refetch = useCallback(() => {
    if (!loading) dispatch(fetchUserChannel({ accountId: profile?.accountId }));
  } , [fetchUserChannel, loading, profile])

  const reset = useCallback(() => {
    if (!loading) dispatch(userChannelSlice.actions.setChannel({ activeChannel: undefined }));
  } , [fetchUserChannel, loading, profile])

  const contextValue = useMemo(() => ({ 
    channels, 
    loading, 
    error, 
    refetch, 
    reset, 
    activeChannel 
  }), [
    channels,
    loading,
    activeChannel,
    error,
    reset,
    refetch,
  ]);

  return <ChannelsContext.Provider value={contextValue}>{children}</ChannelsContext.Provider>;
};


export default ChannelsProvider;